(function () {
  'use strict';

  const root = document.querySelector('[data-sf-cart]');
  if (!root) return;

  const form = root.querySelector('[data-sf-cart-form]');
  if (!form) return;

  const FOREIGN_TC = '22222222222';

  const kurumsalWrap = form.querySelector('[data-sf-kurumsal]');
  const faturaRadios = form.querySelectorAll('[name="fatura_tipi"]');
  const tcInput = form.querySelector('[name="tc_kimlik"]');
  const tcFieldRow = form.querySelector('[data-sf-tc-row]');
  const tcForeignCheckbox = form.querySelector('[data-sf-tc-foreign]');
  const sirketInput = form.querySelector('[name="sirket_adi"]');
  const vergiNoInput = form.querySelector('[name="vergi_no"]');
  const vergiDairesiInput = form.querySelector('[name="vergi_dairesi"]');

  // ---------- Toggle kurumsal panel + TC kimlik visibility ----------
  function getFatura() {
    const checked = form.querySelector('[name="fatura_tipi"]:checked');
    return checked ? checked.value : 'bireysel';
  }
  function syncFaturaVisibility() {
    const isKurumsal = getFatura() === 'kurumsal';
    if (kurumsalWrap) kurumsalWrap.hidden = !isKurumsal;
    // TC kimlik is only required for Bireysel — hide its row when Kurumsal
    if (tcFieldRow) tcFieldRow.hidden = isKurumsal;
  }
  // Wipe form values for the type the user just switched AWAY from, so stale
  // data from a previous selection doesn't follow the order through to ops.
  function clearOtherTypeFields() {
    if (getFatura() === 'kurumsal') {
      if (tcInput) tcInput.value = '';
      if (tcForeignCheckbox) tcForeignCheckbox.checked = false;
    } else {
      if (sirketInput) sirketInput.value = '';
      if (vergiNoInput) vergiNoInput.value = '';
      if (vergiDairesiInput) vergiDairesiInput.value = '';
    }
  }
  faturaRadios.forEach((r) => r.addEventListener('change', () => {
    syncFaturaVisibility();
    clearAllErrors();
    clearOtherTypeFields();
    saveAttributes();
  }));
  syncFaturaVisibility();

  // ---------- Foreigner TC checkbox ----------
  // When checked, the customer is not a Turkish citizen — disable the TC input,
  // skip validation, and persist tc_kimlik=22222222222 so ops can identify the
  // record as a foreigner placeholder.
  function syncForeignTcState() {
    if (!tcForeignCheckbox || !tcInput) return;
    const isForeign = tcForeignCheckbox.checked;
    tcInput.disabled = isForeign;
    if (isForeign) {
      tcInput.value = '';
      tcInput.placeholder = 'T.C. Vatandaşı değil';
    } else {
      tcInput.placeholder = '11 haneli TC Kimlik No';
    }
  }
  if (tcForeignCheckbox) {
    tcForeignCheckbox.addEventListener('change', () => {
      syncForeignTcState();
      clearAllErrors();
      saveAttributes();
    });
    syncForeignTcState();
  }

  // ---------- Build the cart attribute payload for the *current* fatura tipi ----------
  // Setting an attribute to '' tells Shopify to remove it. We always blank out
  // the irrelevant fields so a Bireysel order never carries leftover Kurumsal data
  // (and vice versa) — operators must see exactly the chosen invoice type's fields.
  function buildAttributePayload() {
    const fatura = getFatura();
    const isForeign = !!tcForeignCheckbox?.checked;

    if (fatura === 'kurumsal') {
      return {
        fatura_tipi: 'kurumsal',
        sirket_adi: getValue('sirket_adi'),
        vergi_no: getValue('vergi_no'),
        vergi_dairesi: getValue('vergi_dairesi'),
        tc_kimlik: '',
        tc_vatandasi_degil: '',
      };
    }

    // bireysel (default)
    return {
      fatura_tipi: 'bireysel',
      tc_kimlik: isForeign ? FOREIGN_TC : getValue('tc_kimlik'),
      tc_vatandasi_degil: isForeign ? 'true' : '',
      sirket_adi: '',
      vergi_no: '',
      vergi_dairesi: '',
    };
  }

  // ---------- Save cart attributes (debounced) ----------
  let saveTimer = null;
  let savePromise = null;
  function saveAttributes() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(() => {
      savePromise = fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: buildAttributePayload() }),
      }).catch(() => {/* best-effort */});
    }, 400);
  }
  // Flush any pending debounced save and wait for the in-flight one to finish.
  // Used before any operation that depends on a stable cart state (line removal).
  async function flushSave() {
    if (saveTimer) {
      clearTimeout(saveTimer);
      saveTimer = null;
      savePromise = fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: buildAttributePayload() }),
      }).catch(() => {});
    }
    if (savePromise) await savePromise;
  }

  function getValue(name) {
    const el = form.querySelector(`[name="${name}"]`);
    if (!el) return '';
    if (el.type === 'radio') {
      const checked = form.querySelector(`[name="${name}"]:checked`);
      return checked ? checked.value : '';
    }
    return el.value.trim();
  }

  // Persist on every input
  form.querySelectorAll('input[type="text"]').forEach((el) => {
    el.addEventListener('input', saveAttributes);
  });

  // ---------- Validation + checkout ----------
  function setFieldError(input, message) {
    if (!input) return;
    const field = input.closest('.sf-field');
    if (field) field.classList.add('sf-field--has-error');
    // Look for sibling .sf-error
    let errEl = field?.nextElementSibling;
    if (errEl && errEl.classList.contains('sf-error')) {
      errEl.textContent = message;
    }
  }
  function clearAllErrors() {
    form.querySelectorAll('.sf-field--has-error').forEach((f) => f.classList.remove('sf-field--has-error'));
    form.querySelectorAll('.sf-error').forEach((e) => (e.textContent = ''));
  }

  function validate() {
    clearAllErrors();
    const fatura = getFatura();
    const isForeign = !!tcForeignCheckbox?.checked;

    if (fatura === 'bireysel' && !isForeign) {
      const tc = (tcInput?.value || '').trim();
      if (!/^\d{11}$/.test(tc)) {
        setFieldError(tcInput, 'TC Kimlik No 11 haneli olmalıdır.');
        tcInput?.focus();
        tcInput?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
    }

    if (fatura === 'kurumsal') {
      const sirket = getValue('sirket_adi');
      const vergi = getValue('vergi_no');
      if (!sirket) {
        setFieldError(sirketInput, 'Lütfen şirket / kurum adını giriniz.');
        sirketInput?.focus();
        sirketInput?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      if (!vergi) {
        setFieldError(vergiNoInput, 'Lütfen vergi numarasını giriniz.');
        vergiNoInput?.focus();
        vergiNoInput?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
    }

    return true;
  }

  // ---------- Line item removal ----------
  // POSTs to /cart/change.js with the line key. We use a fresh fetch (not the
  // legacy ?id=...&quantity=0 GET, which is what `item.url_to_remove` produces
  // and which silently breaks for line items with properties whose composite
  // key gets stale after a concurrent /cart/update.js call).
  document.querySelectorAll('[data-sf-remove]').forEach((btn) => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const key = btn.dataset.lineKey;
      if (!key) return;
      btn.disabled = true;

      // Wait for any in-flight attribute save to settle so the line key
      // we just rendered is still the canonical one Shopify recognizes.
      await flushSave();

      try {
        const r = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 }),
        });
        if (!r.ok) {
          const err = await r.json().catch(() => ({}));
          throw new Error(err.description || 'Ürün sepetten çıkarılamadı.');
        }
        // Reload to re-render the cart with the line removed and totals updated.
        window.location.reload();
      } catch (err) {
        alert(err.message);
        btn.disabled = false;
      }
    });
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (!validate()) return;

    // Final synchronous attribute save before checkout — uses the same conditional
    // payload as the debounced auto-save so the chosen fatura tipi is the only one
    // persisted on the order.
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: buildAttributePayload() }),
      });
    } catch (e) {}

    window.location.href = '/checkout';
  });
})();
